import * as yup from "yup";
import { questionnaireSchema } from "../schemas";

export const patientQuestionnaireSchema = yup.object({
  id: yup.number().required(),
  patient_id: yup.number().required(),
  appointment_id: yup.number().nullable(),
  status: yup.number().required(),
  answers: yup
    .array()
    .of(
      yup.object({
        id: yup.number().required(),
        patient_questionnaire_id: yup.number().required(),
        question_id: yup.number().required(),
        question_type: yup.string().nullable(),
        score: yup.number().nullable(),
        answer: yup.array().of(yup.string()).required(),
        comment: yup.string().nullable(),
      }),
    )
    .required(),
  questionnaire: questionnaireSchema.required(),
  procedures: yup
    .array()
    .of(
      yup.object({
        id: yup.number().required(),
        doctor_name: yup.string().nullable(),
      }),
    )
    .nullable(),
  already_on_file: yup.string().nullable(),
  user_marked_already_on_file: yup.string().nullable(),
  step_history: yup.array().of(yup.number()).nullable(),
  provider_only: yup.number().required(),
  updated_at: yup.string().nullable(),
  patient: yup
    .object({
      id: yup.number().required(),
      full_name: yup.string().required(),
      date_of_birth: yup.string().nullable(),
    })
    .required(),
});
